import React from 'react';
import { motion } from 'framer-motion';
export function Header() {
  return <header className="w-full py-8 text-center border-b border-brown-light/30 bg-cream" data-id="element-71">
      <motion.div initial={{
      opacity: 0,
      y: -10
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.6
    }} className="max-w-3xl mx-auto px-4" data-id="element-72">
        <h1 className="font-handwriting text-5xl md:text-6xl text-forest mb-2" data-id="element-73">
          Napftagebuch
        </h1>
        <p className="font-serif text-brown-dark/70 italic text-lg" data-id="element-74">
          Ehrliche Geschichten aus dem Hundealltag
        </p>
      </motion.div>
    </header>;
}